import { DATA_WELL, DONUT, GAUGE, PIE } from 'reporting-data/constants/chartTypes';
import { getDimensions, getMetrics } from 'reporting-data/report/configReportGetters';
import { getReportChartType } from 'reporting-data/report/reportGetters';
import { RELATIONAL } from 'reporting-snowflake/relational/schema/report-records';
import { getMeasuresWithoutExcludedPrefixes, getDimensions as getSnowflakeDimensions } from 'reporting-snowflake/relational/utils/column-utils';
import { getReportVisualType } from 'reporting-snowflake/relational/utils/report-utils';
export const MeasureSizeReasons = {
  ChartType: 'ChartType',
  NumDimensions: 'NumDimensions',
  NumMetrics: 'NumMetrics'
};
const getMeasureSizeRanges = report => {
  const reportIsRelationalReport = report.type === RELATIONAL;
  let chartType;
  let dimensions;
  let metrics;
  if (reportIsRelationalReport) {
    const relationalReport = report;
    chartType = getReportVisualType(relationalReport);
    dimensions = getSnowflakeDimensions(relationalReport.columns);
    metrics = getMeasuresWithoutExcludedPrefixes(relationalReport.columns);
  } else {
    const configReport = report;
    chartType = getReportChartType(configReport);
    dimensions = getDimensions(configReport);
    metrics = getMetrics(configReport);
  }
  if ([PIE, DONUT].includes(chartType)) {
    return {
      minDimensions: 0,
      maxDimensions: 1,
      minMetrics: 1,
      maxMetrics: 1,
      reason: MeasureSizeReasons.ChartType
    };
  }
  if (chartType === GAUGE) {
    return {
      minDimensions: 0,
      maxDimensions: 0,
      minMetrics: 1,
      maxMetrics: 1,
      reason: MeasureSizeReasons.ChartType
    };
  }
  if (DATA_WELL === chartType) {
    if (dimensions.size === 0 && metrics.size === 0) {
      return {
        minDimensions: 1,
        maxDimensions: 1,
        minMetrics: 1,
        maxMetrics: Infinity
      };
    }
    if (dimensions.size === 0 && metrics.size < 2) {
      return {
        minDimensions: 0,
        maxDimensions: 1,
        minMetrics: 1,
        maxMetrics: Infinity
      };
    }
    if (metrics.size > 1) {
      return {
        minDimensions: 0,
        maxDimensions: 0,
        minMetrics: 1,
        maxMetrics: Infinity
      };
    }
    return {
      minDimensions: 0,
      maxDimensions: 1,
      minMetrics: 1,
      maxMetrics: 1
    };
  }
  if (metrics.size > 1) {
    return {
      minDimensions: 0,
      maxDimensions: 1,
      minMetrics: 1,
      maxMetrics: Infinity,
      reason: MeasureSizeReasons.NumMetrics
    };
  }
  if (dimensions.size < 2) {
    return {
      minDimensions: metrics.size > 0 ? 0 : 1,
      maxDimensions: 2,
      minMetrics: 1,
      maxMetrics: Infinity,
      reason: MeasureSizeReasons.NumDimensions
    };
  }
  return {
    minDimensions: metrics.size > 0 ? 0 : 1,
    maxDimensions: 2,
    minMetrics: 1,
    maxMetrics: 1
  };
};
export default getMeasureSizeRanges;